import { SourceType } from 'module/api/filter/types';
import { asUserMetaData } from 'module/helpers/filter/as-user-field-meta';
import { filterableFieldType } from 'module/helpers/filter/type-transformers';
import { useTranslate } from 'module/hooks/use-translation';
import { FieldType } from 'module/types/filter-field/field/field';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { camelCase } from 'lodash';
import { useGetExternalTeamMembersFieldsQuery } from 'queries/fields';
import {
  useGetAllActiveExternalUsersQuery,
  useGetAllActiveNativeUsersQuery,
} from 'queries/member';
import { useMemo } from 'react';

export const roleFieldName = 'jobLevel';

export const useExternalTeamMemberCustomFieldsAsFilterableFields = () => {
  const translate = useTranslate();
  const { data: peopleFields, isLoading } =
    useGetExternalTeamMembersFieldsQuery();
  const { data: nativeUsers, isLoading: isUserLoading } =
    useGetAllActiveNativeUsersQuery();
  const { data: externalUsers, isLoading: isExternalUserLoading } =
    useGetAllActiveExternalUsersQuery();
  const userMeta = useMemo(() => {
    const usersData = [...(nativeUsers ?? []), ...(externalUsers ?? [])];

    return asUserMetaData(usersData ?? []);
  }, [nativeUsers, externalUsers]);

  return useMemo(
    () => ({
      loading: isLoading || isUserLoading || isExternalUserLoading,
      fields: (
        (peopleFields ?? [])
          .map((field) => ({
            ...field,
            fieldLabel:
              field.fieldName === roleFieldName
                ? translate('role')
                : field.fieldLabel,
            fieldName: camelCase(field.fieldName),
            type: filterableFieldType(field),
            sourceType: SourceType.User,
          }))
          .map((field) =>
            [FieldType.SingleUser, FieldType.MultiUser].includes(field.type)
              ? { ...field, metaData: userMeta }
              : field,
          ) as FilterableField[]
      ).filter((field) => field.isEnabled),
    }),
    [
      isLoading,
      isUserLoading,
      isExternalUserLoading,
      peopleFields,
      translate,
      userMeta,
    ],
  );
};
